/* =============================================================
   VITALY — Interactions du thème
   ============================================================= */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.Vitaly && window.Vitaly.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','));
  };

  /* ---------------------------------------------- Révélation au défilement */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------- Entête collante */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------------------------------------------------ Barre d'annonce */
  function initAnnounce() {
    var rotator = document.querySelector('[data-announce-rotator]');
    if (!rotator) return;
    var items = rotator.querySelectorAll('.announce__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  }

  /* ------------------------------------------------------- Tiroirs */
  var openDrawer = null;
  var lastFocus = null;

  function trapFocus(e) {
    if (!openDrawer || e.key !== 'Tab') return;
    var focusables = openDrawer.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function closeDrawer() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('.overlay').forEach(function (o) { o.classList.remove('is-open'); });
    document.body.style.overflow = '';
    openDrawer = null;
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  function showDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocus = document.activeElement;
    if (openDrawer) closeDrawer();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var overlay = document.querySelector('.overlay');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    openDrawer = drawer;
    var focusTarget = drawer.querySelector('[data-drawer-close]');
    if (focusTarget) focusTarget.focus();
  }

  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        showDrawer(opener.getAttribute('data-drawer-open'));
        return;
      }
      if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('overlay')) {
        e.preventDefault();
        closeDrawer();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
      trapFocus(e);
    });
  }

  /* ----------------------------------------------------- Accordéons */
  function initAccordions() {
    document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.setAttribute('data-open', String(!expanded));
      });
    });
  }

  /* ------------------------------------------------ Galerie produit */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (main && src) { main.src = src; main.alt = alt; }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
      });
    });
  }

  /* --------------------------------------- Sélecteur de quantité */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-qty-step'), 10);
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------ Achat collant (page produit) */
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    var anchor = document.querySelector('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ------------------------------------- Variantes de produit (PDP) */
  function initVariants() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var data = document.querySelector('[data-variant-json]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }

    var idInput = form.querySelector('[name="id"]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var submit = form.querySelector('[data-add-btn]');

    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var sw = e.target.closest('.swatch');
        if (!sw) return;
        e.preventDefault();
        group.querySelectorAll('.swatch').forEach(function (s) { s.setAttribute('aria-checked', String(s === sw)); });
        update();
      });
    });

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (group) {
        var active = group.querySelector('.swatch[aria-checked="true"]');
        return active ? active.getAttribute('data-value') : null;
      });
    }

    function update() {
      var opts = selected();
      var match = variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceNow) priceNow.textContent = money(match.price);
      if (priceWas) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceWas.textContent = money(match.compare_at_price);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? (submit.getAttribute('data-label-add') || 'Ajouter au panier')
          : (submit.getAttribute('data-label-sold') || 'Épuisé');
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    update();
  }

  /* ------------------------------------------- Panier AJAX */
  function refreshCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function reloadCartDrawer() {
    return fetch(window.Routes.cart_url + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-contents]');
        var current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var countEl = parsed.querySelector('[data-cart-item-count]');
        if (countEl) refreshCartCount(parseInt(countEl.getAttribute('data-cart-item-count'), 10) || 0);
      });
  }

  function initCartAjax() {
    /* Ajout au panier */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-add-btn]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-label-adding') || 'Ajout…'; }

      fetch(window.Routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.fromEntries(new FormData(form)))
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Ajout impossible');
          return reloadCartDrawer().then(function () { showDrawer('cart-drawer'); });
        })
        .catch(function (err) {
          var slot = form.querySelector('[data-form-error]');
          if (slot) { slot.textContent = err.message; slot.hidden = false; }
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });

    /* Modification / retrait de ligne */
    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (!remove) return;
      e.preventDefault();
      changeLine(remove.getAttribute('data-cart-remove'), 0);
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      changeLine(input.getAttribute('data-cart-qty'), parseInt(input.value, 10) || 0);
    });

    function changeLine(line, quantity) {
      fetch(window.Routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return reloadCartDrawer(); })
        .then(function () {
          if (document.body.classList.contains('template-cart')) window.location.reload();
        });
    }
  }


  /* ==========================================================================
     Flacon 3D — cylindre à facettes en CSS 3D, étiquette enroulée,
     épaule conique, bec verseur en volume et éclairage spéculaire fixe
     (correct : la silhouette d'un cylindre ne change pas en tournant).
     ========================================================================== */
  function build3D(root) {
    var stage = root.querySelector('[data-b3d-stage]');
    if (!stage) return;
    /* Idempotent : l'éditeur de thème peut relancer l'initialisation */
    stage.innerHTML = '';
    Array.prototype.forEach.call(
      root.querySelectorAll('.b3d__lights, .b3d__glow'),
      function (n) { n.parentNode.removeChild(n); });

    var S = stage.clientWidth / 300;
    var px = function (v) { return (v * S) + 'px'; };

    /* Géométrie (unités de référence, stage 300 × 470) */
    var R = 84,  H = 258, BODY_TOP = 156;
    var SHO_H = 44, SHO_TOP = BODY_TOP - SHO_H;
    var NR = 36, NH = 26, NECK_TOP = SHO_TOP - NH;
    var PR = 42, PH = 40, PUMP_TOP = NECK_TOP - PH;

    var GOLD = 'linear-gradient(180deg,#DFC08A 0%,#C6A059 34%,#9A7532 100%)';
    var PLUM = 'linear-gradient(180deg,#4A3B54 0%,#2E2436 60%,#1B1520 100%)';
    var SHELL = 'linear-gradient(180deg,#F5EFF5 0%,#E6DAE8 100%)';

    var obj = document.createElement('div');
    obj.className = 'b3d__obj';

    function el(cls, css) {
      var d = document.createElement('div');
      d.className = cls;
      for (var k in css) d.style[k] = css[k];
      return d;
    }

    /* --- Étiquette : SVG enroulé autour du corps -------------------------- */
    function texture() {
      var W = 1320, Ht = 660;
      var brand = root.getAttribute('data-brand') || 'VITALY';
      var name  = root.getAttribute('data-name')  || 'LAIT CORPS';
      var desc  = root.getAttribute('data-desc')  || 'NIACINAMIDE 5 % · CÉRAMIDES';
      var size  = root.getAttribute('data-size')  || '250 ML';

      function front(cx) {
        return '<g transform="translate(' + cx + ',0)" text-anchor="middle">'
          + '<text x="0" y="272" font-family="Georgia,serif" font-size="72" letter-spacing="24" fill="#1E1822">' + brand + '</text>'
          + '<line x1="-140" y1="302" x2="140" y2="302" stroke="#A9843C" stroke-width="2"/>'
          + '<text x="0" y="364" font-family="Georgia,serif" font-size="42" letter-spacing="9" fill="#5A5162">' + name + '</text>'
          + '<text x="0" y="420" font-family="Helvetica,Arial,sans-serif" font-size="21" letter-spacing="6" fill="#8C8397">' + desc + '</text>'
          + '<text x="0" y="468" font-family="Helvetica,Arial,sans-serif" font-size="19" letter-spacing="8" fill="#A9843C">' + size + '</text>'
          + '</g>';
      }

      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + W + '" height="' + Ht + '" viewBox="0 0 ' + W + ' ' + Ht + '">'
        + '<defs><linearGradient id="p" x1="0" y1="0" x2="0" y2="1">'
        +   '<stop offset="0" stop-color="#F1E9F2"/><stop offset=".55" stop-color="#E4D7E6"/>'
        +   '<stop offset="1" stop-color="#CBB9D1"/></linearGradient></defs>'
        + '<rect width="' + W + '" height="' + Ht + '" fill="url(#p)"/>'
        + '<rect y="172" width="' + W + '" height="330" fill="#FBF8FA"/>'
        + '<rect y="172" width="' + W + '" height="3" fill="#A9843C" opacity=".5"/>'
        + '<rect y="499" width="' + W + '" height="3" fill="#A9843C" opacity=".5"/>'
        + front(0) + front(W)
        + '<g transform="translate(' + (W / 2) + ',0)" text-anchor="middle">'
        +   '<text x="0" y="252" font-family="Helvetica,Arial,sans-serif" font-size="21" letter-spacing="7" fill="#8C8397">MODE D\'EMPLOI</text>'
        +   '<line x1="-180" y1="294" x2="180" y2="294" stroke="#E2DAE4" stroke-width="2"/>'
        +   '<line x1="-180" y1="332" x2="180" y2="332" stroke="#E2DAE4" stroke-width="2"/>'
        +   '<line x1="-180" y1="370" x2="110" y2="370" stroke="#E2DAE4" stroke-width="2"/>'
        +   '<line x1="-180" y1="408" x2="150" y2="408" stroke="#E2DAE4" stroke-width="2"/>'
        +   '<text x="0" y="470" font-family="Georgia,serif" font-size="28" letter-spacing="11" fill="#A9843C">V</text>'
        + '</g></svg>';

      return 'url("data:image/svg+xml;utf8,' + encodeURIComponent(svg) + '")';
    }

    /* --- Primitives ------------------------------------------------------- */
    function cylinder(o) {
      var n = o.segments, r = o.radius, h = o.height, circ = 2 * Math.PI * r, arc = circ / n;
      for (var i = 0; i < n; i++) {
        var seg = el('b3d__seg', {
          top: px(o.top),
          width: px(arc + 2),
          height: px(h),
          transform: 'translateX(-50%) rotateY(' + (i * 360 / n) + 'deg) translateZ(' + px(r) + ')'
        });
        if (o.texture) {
          seg.style.backgroundColor = '#EEE5EF';
          seg.style.backgroundImage = o.texture;
          seg.style.backgroundSize = px(circ) + ' ' + px(h);
          seg.style.backgroundPosition = px(-i * arc) + ' 0';
          seg.style.backgroundRepeat = 'repeat-x';
        } else {
          seg.style.background = o.fill;
        }
        obj.appendChild(seg);
      }
    }

    /* Tronc de cône : facettes trapézoïdales inclinées — surface lisse,
       contrairement à un empilement de cylindres qui laisse un escalier. */
    function cone(o) {
      var n = o.segments || 26;
      var dr = o.rBottom - o.rTop;
      var L = Math.sqrt(dr * dr + o.height * o.height);      // longueur de la génératrice
      var phi = Math.atan2(dr, o.height) * 180 / Math.PI;    // inclinaison / vertical
      var rm = (o.rTop + o.rBottom) / 2;
      var ym = o.top + o.height / 2;
      var wT = 2 * Math.PI * o.rTop / n;
      var wB = 2 * Math.PI * o.rBottom / n + 2;

      for (var i = 0; i < n; i++) {
        var w = px(wB), h = px(L);
        var xa = px((wB - wT) / 2), xb = px((wB + wT) / 2);
        obj.appendChild(el('b3d__seg', {
          top: px(ym),
          width: w,
          height: h,
          background: o.fill,
          clipPath: 'polygon(' + xa + ' 0, ' + xb + ' 0, ' + w + ' 100%, 0 100%)',
          transform: 'translate(-50%,-50%) rotateY(' + (i * 360 / n) + 'deg)'
                   + ' translateZ(' + px(rm) + ') rotateX(' + phi + 'deg)'
        }));
      }
    }

    function disc(y, r, fill) {
      obj.appendChild(el('b3d__disc', {
        top: px(y), width: px(2 * r), height: px(2 * r), background: fill,
        transform: 'translate(-50%,-50%) rotateX(90deg)'
      }));
    }

    /* --- Assemblage ------------------------------------------------------- */
    cylinder({ segments: 46, radius: R,  height: H,  top: BODY_TOP, texture: texture() });
    cone({ segments: 26, rTop: NR, rBottom: R, height: SHO_H, top: SHO_TOP, fill: SHELL });
    cylinder({ segments: 22, radius: NR, height: NH, top: NECK_TOP, fill: PLUM });
    cylinder({ segments: 22, radius: PR, height: PH, top: PUMP_TOP, fill: GOLD });

    disc(BODY_TOP + H, R,  'radial-gradient(ellipse at 50% 40%, #C4B1CA, #9B89A4)');
    disc(PUMP_TOP,     PR, 'radial-gradient(ellipse at 50% 35%, #EBD3A4, #B08C3F)');

    /* Bec verseur : 6 faces posées à plat dans le MÊME contexte 3D que le
       reste, sinon les navigateurs ne les entrelacent pas correctement. */
    var nw = 28, nh = 19, nd = 52, nz = PR + nd / 2 - 10, ny = PUMP_TOP + 11;
    [
      ['translateZ(' + px(nd / 2) + ')',                 nw, nh, '#CDA764'],
      ['rotateY(180deg) translateZ(' + px(nd / 2) + ')', nw, nh, '#8E6B2C'],
      ['rotateY(-90deg) translateZ(' + px(nw / 2) + ')', nd, nh, '#A9843C'],
      ['rotateY(90deg) translateZ(' + px(nw / 2) + ')',  nd, nh, '#BC9748'],
      ['rotateX(90deg) translateZ(' + px(nh / 2) + ')',  nw, nd, '#E2C489'],
      ['rotateX(-90deg) translateZ(' + px(nh / 2) + ')', nw, nd, '#7A5A23']
    ].forEach(function (f) {
      obj.appendChild(el('b3d__face', {
        top: px(ny),
        width: px(f[1]), height: px(f[2]), background: f[3],
        transform: 'translate(-50%,-50%) translateZ(' + px(nz) + ') ' + f[0]
      }));
    });

    stage.appendChild(obj);

    /* --- Éclairage fixe, hors du contexte 3D ------------------------------ */
    var lights = el('b3d__lights', { width: px(300), height: px(470) });

    function shade(top, r, h, radius, strength, clip) {
      var a = strength || 1;
      lights.appendChild(el('b3d__shade', {
        left: '50%', top: px(top), width: px(2 * r), height: px(h),
        marginLeft: px(-r), borderRadius: radius || '0',
        clipPath: clip || 'none',
        background: 'linear-gradient(90deg,'
          + 'rgba(16,9,20,' + (0.62 * a) + ') 0%, rgba(16,9,20,' + (0.18 * a) + ') 16%,'
          + 'rgba(255,255,255,' + (0.40 * a) + ') 35%, rgba(255,255,255,' + (0.05 * a) + ') 49%,'
          + 'rgba(16,9,20,' + (0.16 * a) + ') 69%, rgba(16,9,20,' + (0.70 * a) + ') 100%)'
      }));
    }
    shade(BODY_TOP, R, H, '0 0 34% 34% / 0 0 5% 5%');
    shade(SHO_TOP, R, SHO_H, '0', 0.8,
      'polygon(' + px(R - NR) + ' 0, ' + px(R + NR) + ' 0, 100% 100%, 0 100%)');
    shade(NECK_TOP, NR, NH, '0', 0.9);
    shade(PUMP_TOP, PR, PH, '0', 0.85);

    root.appendChild(lights);
    root.appendChild(el('b3d__glow', {}));
    stage.appendChild(el('b3d__floor', { top: px(BODY_TOP + H + 16) }));

    /* --- Rotation : automatique + glisser-déposer ------------------------- */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = parseFloat(root.getAttribute('data-speed') || '14');
    var spin = 176, tilt = -8;
    var dragging = false, lastX = 0, lastY = 0, velocity = 0, prev = null;

    function apply() {
      obj.style.transform = 'rotateX(' + tilt + 'deg) rotateY(' + spin + 'deg)';
    }
    apply();

    function frame(ts) {
      if (prev === null) prev = ts;
      var dt = Math.min(80, ts - prev) / 1000;
      prev = ts;
      if (!dragging) {
        if (Math.abs(velocity) > 0.5) { spin += velocity * dt; velocity *= 0.94; apply(); }
        else if (!reduce) { spin += speed * dt; apply(); }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    stage.addEventListener('pointerdown', function (e) {
      dragging = true; velocity = 0;
      lastX = e.clientX; lastY = e.clientY;
      stage.classList.add('is-drag');
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      lastX = e.clientX; lastY = e.clientY;
      spin += dx * 0.5;
      tilt = Math.max(-26, Math.min(12, tilt - dy * 0.18));
      velocity = dx * 12;
      apply();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      stage.addEventListener(ev, function () {
        dragging = false;
        stage.classList.remove('is-drag');
      });
    });
  }

  /* ------------------------------------------------------ Démarrage */
  function boot() {
    initReveal();
    initHeader();
    initAnnounce();
    initDrawers();
    initAccordions();
    initGallery();
    initQty();
    initStickyBuy();
    initVariants();
    initCartAjax();
    document.querySelectorAll('[data-b3d]').forEach(build3D);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-initialisation dans l'éditeur de thème Shopify */
  document.addEventListener('shopify:section:load', boot);
})();
